import axios from "axios";

const HttpRequest = () => {

    const post = (url, model = {}) => {
        let config = {
            headers: {'Content-Type': 'application/json'},
        };
        let token = localStorage.getItem('token');
        if (token) config.headers["Authorization"] = `Bearer ${token}`

        return axios({
            method: "post",
            url: `${process.env.REACT_APP_API_ENDPOINT}/${url}`,
            data: model,
            headers: config.headers
        })
    }

    const get = (url) => {
        return axios({method: "get", url: `${process.env.REACT_APP_API_ENDPOINT}/${url}`})
    }

    return {
        post,
        get
    }
}


export default HttpRequest